export function getChartStatistic(state) {
  return state.chartStatistic;
}
export function getStatAgregate(state) {
  return state.statAgregate;
}
export function getIsWorkspaceEdited(state) {
  return state.isWorkspaceEdited
}
